import React, { useEffect, useState } from "react";
import Banner from "../../components/Banner";
import axios from "../../utils/request";
import "./index.css";
import { useLocation } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";

const DetailPage = () => {
  const [detailInfo, setDetailInfo] = useState<any>({});
  const location = useLocation();
  const { url, id } = location.state || {};
  useEffect(() => {
    const initData = async () => {
      const res: any = await axios.get(url, { params: { id: id } } as any);
      if (res.code === 200) {
        setDetailInfo(res.data);
      }
    };
    initData();
  }, [id]);
  return (
    <div className="detail">
      <Banner />
      <div className="li">
        {detailInfo?.tier ? (
          <div className="tier-box">
            {detailInfo?.tier?.map((item: any) => {
              return (
                <>
                  <span>{item}</span>
                  <RightOutlined />
                </>
              );
            })}
          </div>
        ) : null}
        {detailInfo?.title ? (
          <div className="title">{detailInfo?.title}</div>
        ) : null}
        {detailInfo?.created_time ? (
          <div className="time">{detailInfo?.created_time}</div>
        ) : null}
        <div className="desc">
          <div dangerouslySetInnerHTML={{ __html: detailInfo?.detail }} />
        </div>
      </div>
    </div>
  );
};

export default DetailPage;
